/**
 * API sincronización admin legacy → Django (estudyoo-sync).
 */
import axios from 'axios';
import { clearEstudyooCatalogCache } from '@/services/estudyooCatalogCache';

const BACK = (process.env.VUE_APP_BACK_URL || '').replace(/\/$/, '');
const PREFIX = `${BACK}/estudyoo-sync`;

let _token = localStorage.getItem('estudyoo_django_sync_token') || '';

export function setDjangoSyncToken(token) {
  _token = token || '';
  if (_token) {
    localStorage.setItem('estudyoo_django_sync_token', _token);
  } else {
    localStorage.removeItem('estudyoo_django_sync_token');
    clearEstudyooCatalogCache();
  }
}

export function getDjangoSyncToken() {
  return _token || localStorage.getItem('estudyoo_django_sync_token') || '';
}

function headers() {
  const h = { Accept: 'application/json', 'Content-Type': 'application/json' };
  const t = getDjangoSyncToken();
  if (t) h.Authorization = `Bearer ${t}`;
  return h;
}

export async function loginDjango(username, password) {
  clearEstudyooCatalogCache();
  const { data } = await axios.post(
    `${BACK}/actividades-estudyoo/auth/token/`,
    { username, password },
    { headers: { Accept: 'application/json' } },
  );
  if (data.access_token) setDjangoSyncToken(data.access_token);
  return data;
}

export function getCatalogo() {
  return axios.get(`${PREFIX}/catalogo/`, { headers: headers() });
}

export function iniciarSesion(payload) {
  return axios.post(`${PREFIX}/sesion/iniciar/`, payload, { headers: headers() });
}

export function detalleSesion(sesionId) {
  return axios.get(`${PREFIX}/sesion/${sesionId}/`, { headers: headers() });
}

export function logsSesion(sesionId, params = {}) {
  return axios.get(`${PREFIX}/sesion/${sesionId}/logs/`, { headers: headers(), params });
}

export function listarSesiones(params = {}) {
  return axios.get(`${PREFIX}/sesiones/`, { headers: headers(), params });
}

export function registrarEvento(sesionId, payload) {
  return axios.post(`${PREFIX}/sesion/${sesionId}/evento/`, payload, { headers: headers() });
}

export function finalizarSesion(sesionId, resumen = {}) {
  return axios.post(`${PREFIX}/sesion/${sesionId}/finalizar/`, { resumen }, { headers: headers() });
}

export function upsert(payload) {
  return axios.post(`${PREFIX}/upsert/`, payload, { headers: headers() });
}

export function upsertBulk(payload) {
  return axios.post(`${PREFIX}/upsert/bulk/`, payload, {
    headers: headers(),
    timeout: 120000,
  });
}

export function reconciliar(payload) {
  return axios.post(`${PREFIX}/reconciliar/`, payload, { headers: headers() });
}

export function eliminar(entidad, idExterno, sesionId = null) {
  return axios.post(
    `${PREFIX}/delete/${entidad}/${encodeURIComponent(idExterno)}/`,
    { sesion_id: sesionId, borrar_django: true },
    { headers: headers() },
  );
}

export function listarRegistros(params = {}) {
  return axios.get(`${PREFIX}/registros/`, { headers: headers(), params });
}
